import { html } from '@utils/rendering/html';
import './styles/rdarr.scss';
import '@styles/main.scss';
import 'bootstrap';
import RdarrRoutes from './core/configs/routes/rdarr.routes';
import { createVenusQueryClient, VenusQueryProvider } from '@shared/hooks/http';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { CacheProvider } from './core/utils/context/cache-context';
import { ToastContainer } from 'react-toastify';
import { TimeSpans } from './core/constants/utility/time-spans.constants';
import { FeatureProvider } from '@core/utils/features';

const queryClient = createVenusQueryClient();

const App = ({ _basePath, _token, path }) => {
    return html`<div class="rdarr-app">
        <${VenusQueryProvider} client=${queryClient}>
            <${CacheProvider}>
                <${FeatureProvider}>
                    <${RdarrRoutes} localPath=${path} />
                    <${ToastContainer}
                            position="bottom-right"
                            autoClose=${TimeSpans.FromSeconds(3)}
                            hideProgressBar=${false}
                            newestOnTop=${false}
                            closeOnClick=${true}
                        />
                    <${ReactQueryDevtools} initialIsOpen=${false} />
                </${FeatureProvider}>
            </${CacheProvider}>
        </${VenusQueryProvider}>
    </div>`;
};
export default App;
